export const path = (path, absolute = false) => {
    return absolute ? `${window.location.origin}${path}` : path
}

export const parseUrlProtocolAndHost = (url, path = '') => {
    const parts = url.split('/')
    return `${parts[0]}//${parts[2]}${path}`
}
